import React from "react";
import { FjdFlexSpacer } from "fjd-react-components";

export function FlexSpacer() {
  return <FjdFlexSpacer />;
}
